import { Outlet, NavLink, useNavigate, useLocation, Link } from "react-router-dom"
import { useState, useEffect }           from "react"
import { useAuth }                       from "@/hooks/useAuth"
import { api, clearToken }               from "@/lib/api-client"
import { isDoctorHost }                  from "@/lib/host"
import TenantSwitcher                    from "@/components/TenantSwitcher"

// Inline SVG icons — no external dependency
function HomeIcon()    { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> }
function KeyIcon()     { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg> }
function BarChartIcon(){ return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg> }
function FileTextIcon(){ return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg> }
function UsersIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> }
function QueueIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg> }
function TerminalIcon(){ return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></svg> }
function FlaskIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3h6m-6 0v6L5.8 15.8A2 2 0 0 0 7.6 19h8.8a2 2 0 0 0 1.8-3.2L14 9V3"/></svg> }
function StarIcon()    { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> }
function ReviewIcon()  { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg> }
function ClipboardIcon(){ return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg> }
function PersonIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> }
function WebhookIcon()  { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2"/><path d="M6 7.02h5.99c1.1 0 1.95-.94 2.48-1.9A4 4 0 0 1 22 7c-.01.7-.2 1.4-.57 2"/><circle cx="12" cy="12" r="2"/></svg> }
function GearIcon()     { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg> }
function LayersIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg> }
function GridIcon()     { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> }
function CreditCardIcon(){ return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg> }
function PlugIcon()     { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 2v6"/><path d="M15 2v6"/><path d="M6 8h12v3a6 6 0 0 1-12 0z"/><path d="M12 17v5"/></svg> }

type NavItem = { to: string; label: string; Icon: () => JSX.Element; exact?: boolean }
type NavGroup = {
  title:         string
  items:         NavItem[]
  /**
   * Optional secondary items rendered behind a "+N More · Coming soon"
   * toggle that's collapsed by default. Auto-expands when the user is on
   * one of the secondary routes.
   */
  secondary?:    NavItem[]
  secondaryLabel?: string
}

const TENANT_NAV: NavGroup[] = [
  {
    title: "Overview",
    items: [
      { to: "/app/dashboard", label: "Dashboard",      Icon: HomeIcon     },
      { to: "/app/usage",     label: "Usage",          Icon: BarChartIcon },
      { to: "/app/solutions", label: "Demo / Preview", Icon: GridIcon, exact: true },
    ],
  },
  {
    title: "Solutions",
    items: [
      { to: "/app/solutions/pre-visit",            label: "Pre-Visit Summary",  Icon: LayersIcon },
      { to: "/app/solutions/referral",             label: "Referral Summary",   Icon: LayersIcon },
      { to: "/app/solutions/discharge-summary",    label: "Discharge Summary",  Icon: LayersIcon },
      { to: "/app/solutions/emergency-care",       label: "Emergency Summary",  Icon: LayersIcon },
    ],
    secondary: [
      { to: "/app/solutions/in-consultation",      label: "In-Consultation",    Icon: LayersIcon },
      { to: "/app/solutions/procedure-summary",    label: "Procedure Summary",  Icon: LayersIcon },
      { to: "/app/solutions/handover-summary",     label: "Handover Summary",   Icon: LayersIcon },
      { to: "/app/solutions/patient-summary",      label: "Patient Summary",    Icon: LayersIcon },
    ],
    secondaryLabel: "Coming soon",
  },
  {
    title: "Developers",
    items: [
      { to: "/app/integration",   label: "Integration", Icon: PlugIcon     },
      { to: "/app/sandbox",       label: "Playground",  Icon: FlaskIcon    },
      { to: "/app/docs",          label: "Docs",        Icon: FileTextIcon },
    ],
  },
  // Account section collapsed into a single Settings entry with a
  // hover-flyout revealing Plan & Billing + Team & Invites. See the
  // SettingsWithFlyout component below.
]

const ADMIN_NAV = [
  { to: "/app/admin/console",       label: "Console",           Icon: TerminalIcon },
  { to: "/app/admin/observability", label: "Observability",     Icon: TerminalIcon },
  { to: "/app/admin/tenants",       label: "Tenants",           Icon: UsersIcon    },
  { to: "/app/admin/clinical-ref",  label: "Clinical Ref",      Icon: FlaskIcon    },
  { to: "/app/admin/research",      label: "Model Research",    Icon: StarIcon     },
  { to: "/app/admin/review",        label: "Review Queue",      Icon: ReviewIcon   },
  { to: "/app/admin/templates",     label: "Templates",         Icon: FlaskIcon    },
  { to: "/app/admin/roadmap",       label: "Roadmap",           Icon: StarIcon     },
  { to: "/app/admin/desktop-decisions", label: "Desk Decisions",  Icon: ClipboardIcon },
  { to: "/app/admin/explore",       label: "Founder Explore",   Icon: StarIcon     },
  { to: "/app/admin/doctor-approvals", label: "Doctor Approvals", Icon: UsersIcon },
  { to: "/app/admin/production",    label: "Production",        Icon: TerminalIcon },
  { to: "/app/admin/rules",         label: "Rules Registry",    Icon: ReviewIcon   },
  { to: "/app/admin/app-settings",  label: "App Settings",      Icon: TerminalIcon },
  { to: "/app/admin/validators",    label: "Validators",        Icon: UsersIcon    },
  { to: "/app/admin/legal",         label: "Legal",             Icon: FileTextIcon },
]

const TIER_COLOR: Record<string, string> = {
  enterprise: "text-violet-700 bg-violet-50 border border-violet-200",
  growth:     "text-emerald-700 bg-emerald-50 border border-emerald-200",
  starter:    "text-sky-700 bg-sky-50 border border-sky-200",
  free:       "text-zinc-500 bg-zinc-100 border border-zinc-200",
}

/** Live status dot in the header. Polls /health/deep every 60s.
 *  Click → opens public status page. Visible to all logged-in users. */
function StatusPill() {
  const [state, setState] = useState<"ok" | "degraded" | "down" | "unknown">("unknown")

  useEffect(() => {
    const apiBase = (import.meta.env.VITE_API_URL as string | undefined) ?? "https://api.snowmed.io"
    const check = async () => {
      if (typeof navigator !== "undefined" && navigator.onLine === false) {
        setState("down")
        return
      }
      try {
        const r = await fetch(`${apiBase}/health/deep`, { cache: "no-store" })
        if (!r.ok) { setState("down"); return }
        const j = await r.json() as { status?: string }
        setState(j.status === "ok" ? "ok" : "degraded")
      } catch {
        setState("down")
      }
    }
    check()
    const id = setInterval(check, 60_000)
    const onOnline = () => check()
    window.addEventListener("online", onOnline)
    window.addEventListener("offline", () => setState("down"))
    return () => {
      clearInterval(id)
      window.removeEventListener("online", onOnline)
    }
  }, [])

  const dot =
    state === "ok"       ? "bg-emerald-500"  :
    state === "degraded" ? "bg-amber-500"    :
    state === "down"     ? "bg-rose-500"     :
                           "bg-zinc-300"
  const label =
    state === "ok"       ? "All systems operational" :
    state === "degraded" ? "Degraded performance"    :
    state === "down"     ? "Outage detected"         :
                           "Checking…"

  return (
    <a
      href="https://status.snowmed.io"
      target="_blank"
      rel="noreferrer"
      title={label}
      className="hidden sm:inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-800 hover:bg-zinc-50 px-2 py-1 rounded-md transition-colors"
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${dot} ${state === "ok" ? "" : "animate-pulse"}`} />
      <span>Status</span>
    </a>
  )
}

function NavItemLink({ item, closeMobileNav }: { item: NavItem; closeMobileNav: () => void }) {
  const { to, label, Icon, exact } = item
  return (
    <NavLink
      to={to}
      end={exact}
      onClick={closeMobileNav}
      className={({ isActive }) =>
        `flex items-center gap-2.5 px-3 py-2 rounded-md text-[13px] font-medium transition-colors ${
          isActive
            ? "bg-zinc-900 text-white"
            : "text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900"
        }`
      }
    >
      <Icon />
      {label}
    </NavLink>
  )
}

function NavGroupRender({
  group, firstGroup, closeMobileNav,
}: { group: NavGroup; firstGroup: boolean; closeMobileNav: () => void }) {
  const location = useLocation()
  const onSecondary = !!group.secondary?.some(i => location.pathname.startsWith(i.to))
  const [expanded, setExpanded] = useState(false)
  const open = expanded || onSecondary

  return (
    <div className={firstGroup ? "" : "mt-7"}>
      {group.title && (
        <p className="px-3 pt-2 pb-1.5 text-[10px] font-semibold text-zinc-400 uppercase tracking-widest first:pt-1">
          {group.title}
        </p>
      )}
      {group.items.map(item => (
        <NavItemLink key={item.to} item={item} closeMobileNav={closeMobileNav} />
      ))}
      {group.secondary && group.secondary.length > 0 && (
        <>
          <button
            onClick={() => setExpanded(v => !v)}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-[12px] font-medium text-zinc-400 hover:bg-zinc-50 hover:text-zinc-600 transition-colors"
          >
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`transition-transform ${open ? "rotate-90" : ""}`}
            >
              <polyline points="9 18 15 12 9 6"/>
            </svg>
            <span className="flex-1 text-left">
              {open ? "Show fewer" : `+${group.secondary.length} More`}
              {!open && group.secondaryLabel && (
                <span className="ml-1.5 text-[10px] text-amber-700 bg-amber-50 border border-amber-200 px-1 py-px rounded font-medium align-middle">
                  {group.secondaryLabel}
                </span>
              )}
            </span>
          </button>
          {open && group.secondary.map(item => (
            <NavItemLink key={item.to} item={item} closeMobileNav={closeMobileNav} />
          ))}
        </>
      )}
    </div>
  )
}

/**
 * Collapses Plan & Billing + Team & Invites + Settings into a single sidebar
 * entry. Clicking Settings navigates to the general settings page; hovering
 * (or tapping the chevron) reveals the flyout. The flyout also stays open
 * while any of its children is the active route, so users can see where
 * they are without having to hover.
 */
function SettingsWithFlyout({ closeMobileNav }: { closeMobileNav: () => void }) {
  const [hover, setHover] = useState(false)
  const location = useLocation()
  const inAccount =
    location.pathname.startsWith("/app/billing") ||
    location.pathname.startsWith("/app/team") ||
    location.pathname.startsWith("/app/settings")
  const open = hover || inAccount

  return (
    <div
      className="relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <NavLink
        to="/app/settings"
        onClick={closeMobileNav}
        className={({ isActive }) =>
          `flex items-center gap-2.5 px-3 py-2 rounded-md text-[13px] font-medium transition-colors ${
            isActive || inAccount
              ? "bg-zinc-900 text-white"
              : "text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900"
          }`
        }
      >
        <GearIcon />
        <span className="flex-1">Settings</span>
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="opacity-60"
        >
          <polyline points="18 15 12 9 6 15"/>
        </svg>
      </NavLink>

      {open && (
        <div className="absolute left-0 right-0 bottom-full mb-1 bg-white border border-zinc-200 rounded-lg shadow-lg py-1 z-30">
          <FlyoutLink to="/app/billing"  Icon={CreditCardIcon}  label="Plan & Billing" closeMobileNav={closeMobileNav} />
          <FlyoutLink to="/app/team"     Icon={UsersIcon}       label="Team & Invites" closeMobileNav={closeMobileNav} />
          <FlyoutLink to="/app/settings" Icon={GearIcon}        label="General"        closeMobileNav={closeMobileNav} />
        </div>
      )}
    </div>
  )
}

function FlyoutLink({
  to, Icon, label, closeMobileNav,
}: { to: string; Icon: () => JSX.Element; label: string; closeMobileNav: () => void }) {
  return (
    <NavLink
      to={to}
      onClick={closeMobileNav}
      end
      className={({ isActive }) =>
        `flex items-center gap-2.5 px-3 py-2 text-[13px] transition-colors ${
          isActive
            ? "bg-zinc-900 text-white"
            : "text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900"
        }`
      }
    >
      <Icon />
      {label}
    </NavLink>
  )
}

export default function Layout() {
  const { user, isAdmin } = useAuth()
  const navigate = useNavigate()
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  async function handleLogout() {
    await api.auth.logout().catch(() => {})
    clearToken()
    navigate("/")
  }

  const closeMobileNav = () => setMobileNavOpen(false)

  return (
    <div className="flex h-screen bg-zinc-50 relative">
      {/* Mobile backdrop */}
      {mobileNavOpen && (
        <div
          onClick={closeMobileNav}
          className="md:hidden fixed inset-0 bg-black/40 z-30"
          aria-hidden
        />
      )}

      {/* ── Sidebar ─────────────────────────────────────────────────── */}
      <aside className={`w-52 flex-shrink-0 flex flex-col bg-white border-r border-zinc-100 text-zinc-600 fixed md:static inset-y-0 left-0 z-40 transition-transform md:translate-x-0 ${mobileNavOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}>

        {/* Logo */}
        <div className="px-5 h-14 flex items-center gap-2 border-b border-zinc-100">
          <Link
            to="/app/dashboard"
            onClick={closeMobileNav}
            className="flex-1 flex items-center rounded py-1 -mx-1 px-2 hover:bg-zinc-50 transition-colors cursor-pointer"
            aria-label="Go to dashboard"
          >
            <span className="text-zinc-900 font-bold tracking-tight text-sm">{isDoctorHost() ? "SNOW Web" : "SNOW"}</span>
            <span className="ml-2 text-[10px] font-semibold text-zinc-400 uppercase tracking-widest">API</span>
          </Link>
          {isAdmin && (
            <span className="text-[10px] bg-amber-50 text-amber-600 border border-amber-200 px-1.5 py-0.5 rounded font-medium">admin</span>
          )}
        </div>

        {/* Nav — filter developer chrome on doctor host (summarisenow.snowmed.health). */}
        <nav className="flex-1 flex flex-col px-2 py-3 space-y-0.5 overflow-y-auto">
          {(isDoctorHost()
            ? TENANT_NAV
                .filter(g => g.title !== "Developers")
                .map(g => g.title === "Overview"
                  ? { ...g, items: g.items.filter(i => i.to !== "/app/usage") }
                  : g)
            : TENANT_NAV
          ).map((group, gi) => (
            <NavGroupRender
              key={gi}
              group={group}
              firstGroup={gi === 0}
              closeMobileNav={closeMobileNav}
            />
          ))}

          {/* Spacer pushes Settings / user footer to the bottom. */}
          <div className="flex-1 min-h-[16px]" />

          {isAdmin && (
            <>
              <p className="px-3 pt-4 pb-1 text-[10px] font-semibold text-zinc-400 uppercase tracking-widest">Admin</p>
              {ADMIN_NAV.map(({ to, label, Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={closeMobileNav}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2 rounded-md text-[13px] font-medium transition-colors ${
                      isActive
                        ? "bg-amber-50 text-amber-700 border border-amber-200"
                        : "text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900"
                    }`
                  }
                >
                  <Icon />
                  {label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        {/* Account (pinned, outside scroll so the flyout can escape) */}
        <div className="px-2 py-2 border-t border-zinc-100">
          <SettingsWithFlyout closeMobileNav={closeMobileNav} />
        </div>

        {/* User footer */}
        {user && (
          <div className="px-3 py-3 border-t border-zinc-100 space-y-1">
            <div className="flex items-center gap-2 px-2 py-1.5">
              {user.avatarUrl
                ? <img src={user.avatarUrl} alt="" className="w-5 h-5 rounded-full flex-shrink-0" />
                : <div className="w-5 h-5 rounded-full bg-zinc-200 flex-shrink-0" />
              }
              <div className="min-w-0 flex-1">
                <p className="text-[11px] text-zinc-600 truncate">{user.email}</p>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium flex-shrink-0 ${TIER_COLOR[user.tier] ?? TIER_COLOR.free}`}>
                {user.tier}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="w-full text-left px-2 py-1.5 rounded-md text-[12px] text-zinc-400 hover:text-zinc-700 hover:bg-zinc-50 transition-colors"
            >
              Sign out
            </button>
          </div>
        )}
      </aside>

      {/* ── Main ────────────────────────────────────────────────────── */}
      <main className="flex-1 overflow-auto bg-white w-full md:w-auto">
        {/* Top bar */}
        <div className="h-14 border-b border-zinc-100 flex items-center px-4 sm:px-6 md:px-8 gap-3">
          <button
            onClick={() => setMobileNavOpen(v => !v)}
            className="md:hidden -ml-1 p-2 text-zinc-600 hover:text-zinc-900 rounded"
            aria-label="Toggle navigation"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {mobileNavOpen
                ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                : <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>
              }
            </svg>
          </button>
          <TenantSwitcher />
          <div className="ml-auto flex items-center gap-3">
            <span className="text-xs text-zinc-400 font-mono hidden sm:inline">
              {user?.callsPerDay.toLocaleString()} calls/day
            </span>
            <StatusPill />
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-8 py-5 sm:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
